<div class="kv-container rounded-lg" [formGroup]="form">
  <!-- Key Input: Switches between a select and a text input -->
  <div class="key-container">
    @if (isOtherSelected()) {
    <app-input
      formControlName="key"
      [placeholder]="otherKeyPlaceholder()"
      (blur)="onTouched()"
      variant="blend"
    ></app-input>
    } @else {
    <!-- REPLACE the native select with our custom app-select -->
    <app-select
      formControlName="key"
      (blur)="onTouched()"
      [options]="selectOptions()"
      placeholder="Type"
      variant="blend"
    ></app-select>
    }
  </div>

  <!-- Value Input -->
  <div class="value-container">
    <app-input
      formControlName="value"
      [placeholder]="valuePlaceholder()"
      (blur)="onTouched()"
      variant="blend"
    ></app-input>
  </div>
</div>
